module.exports = __webpack_public_path__ + "static/media/layout8-vid.3ee0fe07.svg";